import axios from 'axios';

const baseDomain = 'https://apps.lavote.gov';

const baseURL = `${baseDomain}/api`;

export default axios.create({
    baseURL
});  
